import styled from "styled-components";
import { Colors } from "../../config/Constants";
import Box from "../Box";
import Button from "../Button";
const downloadIcon = require("../../assets/images/download-icon.png");

interface Props {
  onGenerate: () => void;
  source?: string;
}

const PCRightContainer = ({ onGenerate, source }: Props) => {
  return (
    <Box>
      <QRCodeWrapper>
        {source ? (
          <img src={source} alt="QR" />
        ) : (
          <img
            src={require("../../assets/images/qr.png")}
            style={{ opacity: 0.5 }}
            alt="qr_code"
          />
        )}
        <div style={{ width: "100%" }}>
          <Button
            label="Generate"
            variant="filled"
            color={Colors.solidRed}
            size="small"
            onClick={onGenerate}
            endIcon={downloadIcon}
          />
        </div>
      </QRCodeWrapper>
    </Box>
  );
};

const QRCodeWrapper = styled.div`
  padding: 2rem 2rem 0 2rem;
  display: flex;
  flex-direction: column;
  gap: 3rem;
  align-items: center;
  > img {
    width: 50%;
  }
  @media only screen and (max-width: 768px) {
    padding: 0;
    gap: 0.5rem;

    > img {
      width: 80%;
      margin-bottom: 1rem;
    }
  }
`;

export default PCRightContainer;
